import {request, serviceUrl} from "@/utils/request";
export function getTopology() {
    return request({
      url: serviceUrl.deviceService + '/device/gateway/topology'
    })
  }
 export const data =  {
  "serverDevice": [
    {
      "name": "172.16.4.1",
      "ip": "172.16.4.1",
      "spaceId": null,
      "spaceName": null,
      "status": 1
    },
    {
      "name": "172.16.4.2",
      "ip": "172.16.4.2",
      "spaceId": null,
      "spaceName": null,
      "status": 1
    },
    {
      "name": "172.16.4.4",
      "ip": "172.16.4.4",
      "spaceId": null,
      "spaceName": null,
      "status": 1
    },
    {
      "name": "172.16.4.45",
      "ip": "172.16.4.45",
      "spaceId": null,
      "spaceName": null,
      "status": 1
    },
    {
      "name": "172.16.4.46",
      "ip": "172.16.4.46",
      "spaceId": null,
      "spaceName": null,
      "status": 1
    }
  ],
  "gatewayDevice": {
    "1F-电池室": [
      {
        "name": "1层电池室",
        "ip": "172.16.4.33",
        "spaceId": 1875420827546071000,
        "spaceName": "1F-电池室",
        "status": 1
      }
    ],
    "2F": [
      {
        "name": "2FSL1机房主机1",
        "ip": "172.16.4.5",
        "spaceId": 1875102359617572900,
        "spaceName": "2F",
        "status": 1
      },
      {
        "name": "2FSL1机房主机2",
        "ip": "172.16.4.6",
        "spaceId": 1875102359617572900,
        "spaceName": "2F",
        "status": 1
      },
      {
        "name": "2FSL2机房主机1",
        "ip": "172.16.4.9",
        "spaceId": 1875102359617572900,
        "spaceName": "2F",
        "status": 1
      },
      {
        "name": "2FSL2机房主机2",
        "ip": "172.16.4.10",
        "spaceId": 1875102359617572900,
        "spaceName": "2F",
        "status": 1
      },
      {
        "name": "2FSL4机房主机1",
        "ip": "172.16.4.17",
        "spaceId": 1875102359617572900,
        "spaceName": "2F",
        "status": 1
      },
      {
        "name": "2FSL4机房主机2",
        "ip": "172.16.4.18",
        "spaceId": 1875102359617572900,
        "spaceName": "2F",
        "status": 1
      },
      {
        "name": "2FSL3机房主机1",
        "ip": "172.16.4.13",
        "spaceId": 1875102359617572900,
        "spaceName": "2F",
        "status": 1
      },
      {
        "name": "2FSL3机房主机2",
        "ip": "172.16.4.14",
        "spaceId": 1875102359617572900,
        "spaceName": "2F",
        "status": 1
      }
    ],
    "1F": [
      {
        "name": "单机服务器",
        "ip": "172.16.4.3",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "1FSL1机房主机1",
        "ip": "172.16.4.25",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "1FSL1机房主机2",
        "ip": "172.16.4.26",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "1FSL2机房主机1",
        "ip": "172.16.4.29",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "1FSL2机房主机2",
        "ip": "172.16.4.30",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "1FUPS机房",
        "ip": "172.16.4.36",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "单机服务器8081",
        "ip": "172.16.4.3",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "单机服务器8082",
        "ip": "172.16.4.3",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "单机服务器8083",
        "ip": "172.16.4.3",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "单机服务器8084",
        "ip": "172.16.4.3",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "电力系统",
        "ip": "172.16.4.3",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "群控系统",
        "ip": "172.16.4.3",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "1FSL1机房主机3",
        "ip": "172.16.4.43",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "1FSL1机房主机4",
        "ip": "172.16.4.49",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "1FSL2机房主机3",
        "ip": "172.16.4.47",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      },
      {
        "name": "1F冷却塔配电室",
        "ip": "172.16.4.48",
        "spaceId": 1875420538583691300,
        "spaceName": "1F",
        "status": 1
      }
    ],
    "2F-PDA": [
      {
        "name": "2FUPS机房",
        "ip": "172.16.4.22",
        "spaceId": 1875109607257448400,
        "spaceName": "2F-PDA",
        "status": 1
      },
      {
        "name": "2FPDA机房",
        "ip": "172.16.4.23",
        "spaceId": 1875109607257448400,
        "spaceName": "2F-PDA",
        "status": 1
      }
    ],
    "2F-电池室": [
      {
        "name": "2F电池室",
        "ip": "172.16.4.21",
        "spaceId": 1875104512386044000,
        "spaceName": "2F-电池室",
        "status": 1
      }
    ],
    "B1-PDA": [
      {
        "name": "B1-DCC机房",
        "ip": "172.16.4.39",
        "spaceId": 1879007400296579000,
        "spaceName": "B1-PDA",
        "status": 1
      },
      {
        "name": "B1-PDA",
        "ip": "172.16.4.41",
        "spaceId": 1879007400296579000,
        "spaceName": "B1-PDA",
        "status": 1
      }
    ],
    "2F-PDB": [
      {
        "name": "2FPDB机房",
        "ip": "172.16.4.24",
        "spaceId": 1875111066959122400,
        "spaceName": "2F-PDB",
        "status": 1
      }
    ],
    "B1-PDB": [
      {
        "name": "B1-DCD机房",
        "ip": "172.16.4.40",
        "spaceId": 1879007596116050000,
        "spaceName": "B1-PDB",
        "status": 1
      },
      {
        "name": "B1-PDB",
        "ip": "172.16.4.42",
        "spaceId": 1879007596116050000,
        "spaceName": "B1-PDB",
        "status": 1
      }
    ],
    "1F-PDA": [
      {
        "name": "1层低压配电室A",
        "ip": "172.16.4.34",
        "spaceId": 1875450137501802500,
        "spaceName": "1F-PDA",
        "status": 1
      }
    ],
    "B1-电池室A": [
      {
        "name": "B1-DCA机房",
        "ip": "172.16.4.37",
        "spaceId": 1879008102209212400,
        "spaceName": "B1-电池室A",
        "status": 1
      },
      {
        "name": "B1-DCB机房",
        "ip": "172.16.4.38",
        "spaceId": 1879008102209212400,
        "spaceName": "B1-电池室A",
        "status": 1
      }
    ],
    "1F-PDB": [
      {
        "name": "1层低压配电室B",
        "ip": "172.16.4.35",
        "spaceId": 1875449137835577300,
        "spaceName": "1F-PDB",
        "status": 1
      }
    ],
    "B1": [
      {
        "name": "B1层制冷站",
        "ip": "172.16.4.44",
        "spaceId": 1879006992320823300,
        "spaceName": "B1",
        "status": 1
      }
    ]
  }
}